"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var AnnotationSchemaV3 = {
  VERSION: 3,
  TYPE_PEN: 'PEN',
  TYPE_HIGHLIGHTER: 'HIGHLIGHTER',
  TYPE_TEXT: 'TEXT',
  TYPE_TEXT_TMP: 'TEXT_TMP',
  // list of available colors,
  COLORS: ['f44336', 'E91E63', 'FF9800', 'FFEB3B', '4CAF50', '03A9F4', '9C27B0', 'FFFFFF', '000000'],
  TEXT_FONT_FAMILY: 'helvetica, sans-serif',
  TEXT_LINE_HEIGHT: 1.2
};
/* eslint: no-magic-number: 0 */

var PEN_SIZES = [0.008, 0.015, 0.024];
var HIGHLIGHTER_SIZES = [0.018, 0.028, 0.044];
var TEXT_SIZES = [0.016, 0.032, 0.047];
AnnotationSchemaV3.TYPES = [AnnotationSchemaV3.TYPE_PEN, AnnotationSchemaV3.TYPE_HIGHLIGHTER, AnnotationSchemaV3.TYPE_TEXT];
AnnotationSchemaV3.TYPE_SIZES = {};
AnnotationSchemaV3.TYPE_SIZES[AnnotationSchemaV3.TYPE_PEN] = PEN_SIZES;
AnnotationSchemaV3.TYPE_SIZES[AnnotationSchemaV3.TYPE_HIGHLIGHTER] = HIGHLIGHTER_SIZES;
AnnotationSchemaV3.TYPE_SIZES[AnnotationSchemaV3.TYPE_TEXT] = TEXT_SIZES;
AnnotationSchemaV3.TYPE_COLOR_ALPHA = {};
AnnotationSchemaV3.TYPE_COLOR_ALPHA[AnnotationSchemaV3.TYPE_PEN] = 1;
AnnotationSchemaV3.TYPE_COLOR_ALPHA[AnnotationSchemaV3.TYPE_HIGHLIGHTER] = 0.5;
AnnotationSchemaV3.TYPE_COLOR_ALPHA[AnnotationSchemaV3.TYPE_TEXT] = 1;
var _default = AnnotationSchemaV3;
exports["default"] = _default;